// src/portfolioData.js
// Local portfolio data - no Supabase required
// Sorted by updated_at ascending to match live site order

export const portfolioItems = [
  {
    id: "53b48911-b873-4892-a1e8-751a97ba9055",
    role: "Grip",
    title: "J.I- Thinking Hurts [Grip]",
    video_url: "https://www.youtube.com/embed/moAfqFo3f00"
  },
  {
    id: "ef7b6a42-e926-47a7-97f0-418f241779a7",
    role: "Camera and DIT",
    title: "Heidi Klum Halloween 2023 [Cam and DIT]",
    video_url: "https://www.instagram.com/p/CzMeq4rPI6Z/embed"
  },
  {
    id: "1e545941-8cb1-4d41-b5e9-9f3e91100797",
    role: "General",
    title: "SHAQNLIVIN - HAVING MY WAY FT CAPELLA GREY [DRONE]",
    video_url: "https://www.youtube.com/embed/HeZck91SBIY"
  },
  {
    id: "25aaf32d-b271-44f3-bb20-4e01198b2eb4",
    role: "General",
    title: "KHABY COMING TO AMERICA [PRODUCTION ASSISTANT]",
    video_url: "https://www.youtube.com/embed/sc8DXDWRKac"
  },
  {
    id: "b8077a6a-bd02-4b14-836b-a2199d68dfe0",
    role: "General",
    title: "BIZ MARKIE DOC [PRODUCTION ASSISTANT]",
    video_url: "https://www.youtube.com/embed/hklSInDi5Rc"
  },
  {
    id: "38f3c879-876d-4463-be97-c6f217ad9e10",
    role: "Production Coordinator",
    title: "DEBS HOUSE SEASON 2 [PRODUCTION COORDINATOR]",
    video_url: "https://www.youtube.com/embed/GevNlbu-c4g"
  },
  {
    id: "c93f69bc-ad16-4e8b-876c-a57e4f3f0510",
    role: "Production Assistant",
    title: "PAID IN FULL BBC DOCUSERIES [PA]",
    video_url: "https://www.youtube.com/embed/o64mQaHlStk"
  },
  {
    id: "58d90fd1-37a4-49b9-880e-499bf7cb18c8",
    role: "Production Assistant",
    title: "NEWMAN'S PIZZA COMMERCIAL [ART/PA]",
    video_url: "https://www.tiktok.com/embed/7283951484981710126"
  },
  {
    id: "bb7b19b8-9ba1-49e7-8605-db8ffbb52bae",
    role: "Production Assistant",
    title: "RETAIL ME NOT COMMERCIAL [PA]",
    video_url: "https://www.youtube.com/embed/OQKaBTMbTXQ"
  },
  {
    id: "2bbd09ba-55f9-4124-9bd8-ccefa74dc487",
    role: "Production Assistant",
    title: "STAPLE 21 MERCER GRAND OPENING COMMERCIAL [PA]",
    video_url: "https://www.instagram.com/reel/DJb9jdSRkMi/embed"
  },
  {
    id: "f522006e-cc10-4e30-ba29-5a0cd56b7338",
    role: "Production Assistant",
    title: "JERSEY SHORE FAMILY VACATION SEASON 7 [PA]",
    video_url: "https://www.youtube.com/embed/6UW4Ydnmvv4"
  },
  {
    id: "7f137532-4da9-4b55-888e-b648a823934a",
    role: "Production Assistant",
    title: "GOOGLE PIXEL LOLA BROOKE COMMERCIAL [PA]",
    video_url: "https://www.youtube.com/watch?v=wTEwgRYrnbk"
  },
  {
    id: "9ef3a071-fe84-4f32-86d2-4af062a55926",
    role: "Production Assistant",
    title: "TIAA AND WYCLEF JEAN COMMERCIAL [SWING]",
    video_url: "https://www.tiktok.com/embed/7324750512732081451"
  },
  {
    id: "8e95a58c-2640-4b74-9eea-a71165df8157",
    role: "Swing",
    title: "NEW YORK CITY MARATHON SPONSORED BY NEW BALANCE [SWING]",
    video_url: "https://www.tiktok.com/embed/7433574655476124961"
  },
  {
    id: "1630fdec-d65f-4664-a81c-b278ce8b4728",
    role: "Swing",
    title: "KC CHIEFS COMMERCIAL W/ CHRISTOPHER MELONI (START @4 MINUTES) [SWING]",
    video_url: "https://www.youtube.com/embed/_027x-xqqdU"
  },
  {
    id: "4f772cab-9d87-4f99-8ff9-42987175bd1f",
    role: "Swing",
    title: "O'SHAQUIE FOSTER WITH MARK KREIGEL INTERVIEW FOR TOP RANK [SWING]",
    video_url: "https://www.youtube.com/embed/6z2EUFLr7HU"
  },
  {
    id: "74ef53d3-ffb7-46cd-bd21-3d0c211ec62b",
    role: "Swing",
    title: "SHAKUR STEVENSON WITH MARK KREIGEL INTERVIEW FOR TOP RANK [SWING]",
    video_url: "https://www.instagram.com/reel/C9F_Ck4u2co/embed"
  },
  {
    id: "4ff8d65b-54ff-4a3b-9ea1-9d8dac8d8c1a",
    role: "Scenic",
    title: "2024 LIGHTSCAPE BOTANICAL GARDENS [SCENIC]",
    video_url: "https://www.youtube.com/embed/9UGiypX9SSQ"
  },
  {
    id: "cf660727-ae76-453e-9804-4f1c44c5dc5c",
    role: "Sky Cam Utility",
    title: "ESPN NAVY VS NOTRE DAME GAME [SKY CAM UTILITY]",
    video_url: "https://www.youtube.com/embed/F_O6FdBzH90"
  },
  {
    id: "386e8586-d4c8-4876-8251-59a4a225826c",
    role: "Sky Cam Utility",
    title: "ESPN GIANTS VS JETS GAME [SKY CAM UTILITY]",
    video_url: "https://www.youtube.com/embed/Adtwip2ykKc"
  },
  {
    id: "ad6cf442-76c0-4657-8b9a-2bb3664548b0",
    role: "BTS",
    title: "X MEN MANSION BY AIRBNB [BTS AND PRODUCTION]",
    video_url: "https://www.youtube.com/embed/RUPPRDQo7vo"
  },
  {
    id: "ed2b790d-39df-4637-8dca-d1b3ea92712a",
    role: "Assistant Camera and Drone",
    title: "DEBS HOUSE S1- [ASSISTANT CAMERA AND DRONE]",
    video_url: "https://www.youtube.com/embed/ULjGbYWbJDU"
  },
  {
    id: "3d0b3491-2200-49b7-b5f0-576920e2d064",
    role: "Swing",
    title: "ARYNA SABALENKA TAKES NEW YORK CITY (OFF DAY) [SWING]",
    video_url: "https://www.youtube.com/embed/aD6ul6SNVl8"
  },
  {
    id: "ef7eeb30-dcea-46b2-b25e-62b88dbba55d",
    role: "Swing",
    title: "BRUCE CARRINGTON WITH MARK KREIGEL INTERVIEW FOR TOP RANK [SWING]",
    video_url: "https://www.instagram.com/reel/DAYwE9zuxiX/embed"
  },
  {
    id: "d3f4f9f0-0c03-4836-859e-ea9b33b5d62c",
    role: "Swing",
    title: "MIKAELA MAYER VS SANDY RYAN WITH MARK KREIGEL INTERVIEW FOR TOP RANK [SWING]",
    video_url: "https://www.instagram.com/reel/DAcHcJ4S2ro/embed"
  }
];